import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Typography from "@mui/material/Typography";
import IllustrationTabPanel from "./IllustrationTabPanel";
const previewContent = [
    _jsx(Typography, { children: "Le risque" }, "risk"),
    _jsx(Typography, { children: "La r\u00E9ponse Docaposte" }, "answer"),
    _jsx(Typography, { children: "Ce que \u00E7a change pour vous" }, "benefit"),
];
const IllustrationTabPanelPreview = () => {
    return (_jsx(IllustrationTabPanel, { orientation: "vertical", dynamicList: [
            {
                id: "tab-1",
                label: "Protection des postes",
                borderColor: "#19d3c5",
                icon: { url: "/Subtract-4.svg" },
                illustration: { url: "/Subtract-4.svg" },
                dynamicPart: previewContent,
            },
            {
                id: "tab-2",
                label: "Sauvegarde des données",
                borderColor: "#BF7CFF",
                icon: { url: "/Subtract-4.svg" },
                illustration: { url: "/Subtract-4.svg" },
                dynamicPart: previewContent,
            },
        ] }));
};
export default IllustrationTabPanelPreview;
